
const $ = window.jQuery || window.$;

export const Hawk = {
    w: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    h: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,

    hash: window.location.hash,
    anchorSufix: '-anchor'
}

Hawk.Validator = {};

Hawk.Validator.isEmail = function(email) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
    } else {
        return false;
    }
}

Hawk.Validator.isPhoneNumber = function(number) {
    if (/^\+?[0-9\s]+$/.test(number)) {
        return true;
    } else {
        return false;
    }
}

Hawk.Validator.isNumber = function(number) {
    if (/^[0-9]+$/.test(number)) {
        return true;
    } else {
        return false;
    }
}

Hawk.Validator.isNotEmpty = function(value) {
    if (value.length > 0) {
        return true;
    } else {
        return false;
    }
}

Hawk.Validator.longerThan = function(str, length) {
    if (str.length > length) {
        return true;
    } else {
        return false;
    }
}

Hawk.Validator.greaterThan = function(number, bound) {
    if (number > bound) {
        return true;
    } else {
        return false;
    }
}

Hawk.Validator.isSomethingChecked = function(field) {
    if (field.is(':checked')) {
        return true;
    } else {
        return false;
    }
}

export const Validator = Hawk.Validator

Hawk.createBundleFromString = function(str) {
    var parts = str.split('&');

    var result = {};

    var current;
    var data;
    var key;
    var value;

    for (var i in parts) {
        current = parts[i];

        data = current.split('=');

        key = data[0];
        value = data[1];

        result[key] = value;
    }

    return result;
}

Hawk.isInObject = function(value, obj) {
    for (var k in obj) {
        if (!obj.hasOwnProperty(k)) {
            continue;
        }

        if (obj[k] === value) {
            return true;
        }
    }

    return false;
}

Hawk.mergeObjects = function(mainObject, object) {
    var result = {};

    if (object === undefined) {
        return mainObject;
    }

    for (var property in mainObject) {
        if (mainObject.hasOwnProperty(property)) {
            result[property] = (object.hasOwnProperty(property)) ? object[property] : mainObject[property];
        }

        //console.log("object." + property + ": " + result[property]);
    }

    return result;
}

export const mergeObjects = Hawk.mergeObjects;

Hawk.mergeWholeObjects = function(mainObject, object) {
    var result = {};

    if (object === undefined) {
        return mainObject;
    }

    for (var property in mainObject) {
        if (mainObject.hasOwnProperty(property)) {
            result[property] = mainObject[property];
        }


        //console.log("object." + property + ": " + result[property]);
    }

    for (var property in object) {
        if (object.hasOwnProperty(property)) {
            result[property] = object[property];
        }

        //console.log("object." + property + ": " + result[property]);
    }

    return result;
}

Hawk.createJQueryObject = function(text) {
    var result = $(text);

    result = result.filter(function() {
        return this.nodeType == 1; // Node.NODE
    });

    return result;
}

Hawk.formFieldTypes = {
    TEXT: 'text',
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    TEXTAREA: 'textarea',
    SELECT: 'select',
    FILE: 'file'
};

export const formFieldTypes = Hawk.formFieldTypes;

export const FormField = function(name, type, wrapperClass, required, callback) {
    var that = this;

    this.name = name;
    this.type = type;
    this.wrapperClass = wrapperClass;
    this.required = required;
    this.callback = callback;

    this.wrapper;
    this.field;

    this.errorClass = "error";

    this.bind = function(form) {
        if (this.type == Hawk.formFieldTypes.TEXTAREA) {
            this.field = $(form).find('textarea[name="' + this.name + '"]');
        } else if (this.type == Hawk.formFieldTypes.CHECKBOX) {
            this.field = $(form).find('input[name="' + this.name + '"]');

            if(this.field.length == 0) {
                this.field = $(form).find('input[name="' + this.name + '[]"]');
            }
        } else if (this.type == Hawk.formFieldTypes.SELECT) {
            this.field = $(form).find('select[name="' + this.name + '"]');
        } else {
            this.field = $(form).find('input[name="' + this.name + '"]');
        }

        if (this.field.length > 0) {
            this.wrapper = this.field.parents('.' + this.wrapperClass);
        }
    }

    this.isBinded = function() {
        return (this.wrapper !== undefined && this.field !== undefined);
    }

    this.disable = function() {
        if (this.isBinded()) {
            this.field.attr('disabled', 'disabled');
        }

        return this;
    }

    this.validate = function() {
        if (callback !== undefined) {
            if(that.type == Hawk.formFieldTypes.CHECKBOX || that.type == Hawk.formFieldTypes.RADIO || that.type == Hawk.formFieldTypes.FILE) {
                return callback(that.field, that.wrapper);
            } else {
                return callback(that.field.val());
            }
        }

        return true;
    }

    this.markIncorrect = function() {
        this.wrapper.addClass(this.errorClass);

        return this;
    }

    this.clear = function() {
        this.wrapper.removeClass(this.errorClass);

        return this;
    }

    this.clearField = function() {
        if(that.type == Hawk.formFieldTypes.CHECKBOX || that.type == Hawk.formFieldTypes.RADIO) {
            this.field.attr('checked', false);
        } else if (that.type == Hawk.formFieldTypes.SELECT) {
            this.field.val(0);
        } else {
            this.field.val('');
        }

        return this;
    }

    this.run = function(form) {
        this.bind(form);

        this.field.change(function() {
            if (that.validate()) {
                that.clear();
            } else {
                that.markIncorrect();
            }
        });
    }
}

export const FormSender = function(id, fields, options) {
    var that = this;

    this.id = id;
    this.rawForm = document.getElementById(this.id);
    this.form = $(this.rawForm);

    this.fields = fields;

    this.defaultOptions = {
        ajaxPath: '/ajax.php',
        extraData: {},
        incorrectFieldClass: 'error',
        button: that.form.find('button[type="submit"]'),
        cancelButton: that.form.find('button.form__cancel'),
        infoContainerClass: 'form__info-container',
        infoWrapperClass: 'form__info-wrapper',
        infoClass: 'form__info',
        spinnerClass: 'form__spinner',
        correctCallback: function() {},
        errorCallback: function() {},
        callback: function() {}
    };

    this.options = Hawk.mergeObjects(this.defaultOptions, options);

    this.infoContainer = this.form.find('.' + this.options.infoContainerClass);
    this.infoWrapper = this.form.find('.' + this.options.infoWrapperClass);
    this.info = this.form.find('.' + this.options.infoClass);
    this.spinner = this.form.find('.' + this.options.spinnerClass);
    this.button = this.options.button;
    this.cancelButton = this.options.cancelButton;

    this.validate = function() {
        var result = true;

        for (var i in this.fields) {
            var current = this.fields[i];

            if (!current.validate()) {
                current.markIncorrect();

                result = false;
            } else {
                current.clear();
            }
        }

        return result;
    }

    this.clear = function() {
        for (var i in this.fields) {
            var current = this.fields[i];

            current.clear();
        }

        return this;
    }

    this.clearFields = function() {
        for (var i in this.fields) {
            var current = this.fields[i];

            current.clearField();
        }

        return this;
    }

    this.checkFields = function(incorrectFields) {
        for (var i in this.fields) {
            var current = this.fields[i];

            if (Hawk.isInObject(current.name, incorrectFields)) {
                current.markIncorrect();
            } else {
                current.clear();
            }
        }

        return this;
    }

    this.changeMessage = function(message) {
        var showing = function() {
            that.info.html(message);

            that.infoWrapper.slideDown({
                duration: 200,
                complete: function() {
                    that.infoContainer.css({ 'min-height': that.infoContainer.outerHeight() + "px" });

                    that.showMessage();
                }
            });
        }

        if (this.infoWrapper.is(':hidden')) {
            showing();
        } else {
            that.hideMessage(showing);
        }

        return this;
    }

    this.showMessage = function(message) {
        that.info.animate({ opacity: 1 }, {
            duration: 200
        });

        return this;
    }

    this.hideMessage = function(callback) {
        this.info.animate({ opacity: 0 }, {
            duration: 200,
            complete: function() {
                if (callback !== undefined) {
                    callback();
                }
            }
        });

        return this;
    }

    this.clearMessage = function(callback) {
        this.info.animate({ opacity: 0 }, {
            duration: 200,
            complete: function() {
                that.infoWrapper.slideUp({
                    duration: 200,
                    complete: function() {
                        that.infoContainer.css({ 'min-height': 0 });

                        if (callback !== undefined) {
                            callback();
                        }
                    }
                });
            }
        });

        return this;
    }

    this.hideButton = function() {
        this.button.add(this.cancelButton).animate({ opacity: 0 }, {
            duration: 200,
            complete: function() {
                that.button.css({ visibility: 'hidden' });
            }
        });
    }

    this.disable = function() {
        this.form.attr('disabled', 'disabled');

        this.form.find('input, textarea').attr('disabled', 'disabled');

        return this;
    }

    this.send = function() {
        this.spinner.show();

        var data = new FormData(that.rawForm);

        for (var key in that.options.extraData) {
            data.append(key, that.options.extraData[key]);
        }

        console.log("Sending form");

        $.ajax({
            url: that.options.ajaxPath,
            type: 'POST',
            data: data,
            cache: false,
            processData: false, // Don't process the files
            contentType: false,
            dataType: 'json',
            success: function(result) {
                console.log(result);

                if (!result.error) {
                    //that.changeMessage(result.message);

                    that.clear();

                    that.hideButton();

                    that.disable();

                    if (typeof that.options.correctCallback == 'function') {
                        that.options.correctCallback(result);
                    }
                } else {
                    that.checkFields(result.errorFields);

                    that.changeMessage(result.message);

                    if (typeof that.options.errorCallback == 'function') {
                        that.options.errorCallback(result);
                    }
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(jqXHR.responseText);

                that.changeMessage("Wystąpił nieoczekiwany problem podczas wysyłania wiadomości. Proszę spróbować ponownie później.");

                //console.log(errorThrown);
            },
            complete: function(jqXHR) {
                that.spinner.hide();
            }
        });
    }

    this.bindFields = function() {
        for (var i in this.fields) {
            var current = this.fields[i];

            current.run(that.form);
        }

        return this;
    }

    this.run = function() {
        this.bindFields();

        this.form.submit(function(e) {
            e.preventDefault();

            that.send();
        });

        this.cancelButton.click(function() {
            that.clearFields();
        });
    }
}

Hawk.Invoker = function(options) {
    this.callbacks = {};
    this.refreshing;

    this.defaultOptions = {
        timeSpace: 100
    };

    this.options = Hawk.mergeObjects(this.defaultOptions, options);

    this.register = function(name, callback) {
        this.callbacks[name] = callback;

        return this;
    }

    this.cancel = function(name) {
        if (typeof this.callbacks[name] != 'undefined') {
            delete this.callbacks[name];

            return true;
        } else {
            return false;
        }
    }

    this.invoke = function() {
        for (var i in this.callbacks) {
            this.callbacks[i]();
        }

        return this;
    }

    this.run = function() {
        var that = this;

        this.invoke();

        $(window).resize(function() {
            clearTimeout(that.refreshing);

            that.refreshing = setTimeout(function() {
                that.invoke();
            }, that.options.timeSpace);
        });
    }
}

Hawk.refresh = function() {
    this.w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeigh;

    return this;
}

Hawk.run = function() {
    var that = this;

    $(window).resize(function() {
        that.refresh();
    });
}

export const Hawky = Hawk;


// WEBPACK FOOTER //
// ./src/hawk.js
